var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
function SvgEdit16(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '1rem', height: '1rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("path", { d: "M12.793 1.086L13.939-.06l2.121 2.12-1.146 1.147zM1.586 12.293L0 16l3.707-1.586-2.121-2.121zm.707-.707l9.792-9.793 2.122 2.122-9.793 9.792z" })));
}
var ForwardRef = React.forwardRef(SvgEdit16);
export default ForwardRef;
